<template>
	<div>
		<q-table
			:data="data"
			:columns="columns"
			:pagination.sync="server_pagination"
			@request="request"
			:loading="loading"
			:filter="filter"
			row-key="title"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
		>
			<template slot="top" slot-scope="props">
				<q-search
					v-model="filter"
					icon="far fa-search"
					:placeholder="$t('search')"
					:debounce="500"
				/>
				<div class="col" />
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props" :props="props">
				<q-td key="user_id" :props="props">
					{{ props.row.user_id }}
				</q-td>

				<q-td key="user_full_name" :props="props">
					{{ props.row.user_full_name }}
				</q-td>

				<q-td key="user_email" :props="props">
					{{ props.row.user_email }}
				</q-td>

				<q-td key="user_profile" :props="props">
					{{ props.row.user_profile }}
				</q-td>

				<q-td key="user_points" :props="props">
					{{ props.row.user_points }}
				</q-td>

				<q-td key="user_total_points" :props="props">
					{{ props.row.user_total_points }}
				</q-td>

				<q-td key="user_status" :props="props" auto-width>
					<q-chip
						small
						:icon="getIconStatus(props.row.user_status)"
						:color="getColorStatus(props.row.user_status)"
						class="full-width"
					>
						{{ $t(getStatus(props.row.user_status)) }}
					</q-chip>
				</q-td>

				<q-td auto-width key="actions" :props="props">
					<q-btn
						flat
						round
						color="negative"
						icon="far fa-ban"
						@click="confirmBlockUser(props.row)"
					/>
					<q-btn
						flat
						round
						color="negative"
						icon="far fa-trash-alt"
						@click="confirmRemoveUser(props.row)"
					/>
				</q-td>
			</q-tr>
		</q-table>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="primary"
					class="full-width"
					:label="$t('email_points_available')"
					icon="far fa-inbox-out"
					@click="confirm_email_points_available = true"
				/>
			</div>

			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="primary"
					class="full-width"
					:label="$t('email_end_of_campaign')"
					icon="far fa-inbox-out"
					@click="confirm_email_end_of_campaign = true"
				/>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-sm">
			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'campaigns' })"
				/>
			</div>
		</div>

		<q-dialog v-model="confirm_block_user">
			<span slot="title">{{ $t('block_user') }}</span>

			<span slot="message">{{
				$t(
					'confirm_block_user_the_user_will_not_be_abble_to_access_the_program_while_blocked_and_will_need_to_be_manually_unblocked_on_the_user_management_screeen'
				)
			}}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="primary" :label="$t('cancel')" @click="confirm_block_user = false" />
				<q-btn color="negative" :label="$t('confirm')" @click="blockUser()" />
			</template>
		</q-dialog>

		<q-dialog v-model="confirm_remove_user">
			<span slot="title">{{ $t('remove_user_from_campaign') }}</span>

			<span slot="message">{{
				$t(
					'confirm_remove_this_user_from_campaign_this_will_remove_all_the_sales_that_the_user_has_registered_and_will_remove_all_his_points_as_well_this_action_cannot_be_undone'
				)
			}}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="primary" :label="$t('cancel')" @click="confirm_remove_user = false" />
				<q-btn color="negative" :label="$t('confirm')" @click="removeUserFromCampaign()" />
			</template>
		</q-dialog>

		<q-dialog v-model="confirm_email_points_available">
			<span slot="title">{{ $t('email_points_available') }}</span>

			<span slot="message">{{
				$t(
					'confirm_sending_a_email_to_the_audience_of_this_campaign_with_the_available_points'
				)
			}}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="primary"
					:label="$t('cancel')"
					@click="confirm_email_points_available = false"
				/>
				<q-btn
					color="positive"
					:label="$t('confirm')"
					@click="sendEmailPointsAvailable()"
				/>
			</template>
		</q-dialog>

		<q-dialog v-model="confirmation_email_points_available">
			<span slot="title">{{ $t('email_points_available') }}</span>

			<span slot="message">{{ $t('message_send_success') }}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="primary"
					:label="$t('ok')"
					@click="confirmation_email_points_available = false"
				/>
			</template>
		</q-dialog>

		<q-dialog v-model="confirm_email_end_of_campaign">
			<span slot="title">{{ $t('email_end_of_campaign') }}</span>

			<span slot="message">{{
				$t(
					'confirm_sending_a_email_to_the_audience_of_this_campaign_with_the_warning_that_the_campaign_is_ending'
				)
			}}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="primary"
					:label="$t('cancel')"
					@click="confirm_email_end_of_campaign = false"
				/>
				<q-btn color="positive" :label="$t('confirm')" @click="sendEmailEndOfCampaign()" />
			</template>
		</q-dialog>

		<q-dialog v-model="confirmation_email_end_of_campaign">
			<span slot="title">{{ $t('email_end_of_campaign') }}</span>

			<span slot="message">{{ $t('message_send_success') }}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="primary"
					:label="$t('ok')"
					@click="confirmation_email_end_of_campaign = false"
				/>
			</template>
		</q-dialog>

		<q-dialog v-model="confirmation_block_user">
			<span slot="title">{{ $t('block_user') }}</span>

			<span slot="message">{{
				$t(
					'user_blocked_you_will_need_to_manually_unblock_the_user_on_the_user_management_screen'
				)
			}}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="primary" :label="$t('ok')" @click="confirmation_block_user = false" />
			</template>
		</q-dialog>

		<q-dialog v-model="confirmation_remove_user">
			<span slot="title">{{ $t('remove_user_from_campaign') }}</span>

			<span slot="message">{{ $t('user_removed_from_campaign') }}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="primary"
					:label="$t('ok')"
					@click="confirmation_remove_user = false"
				/>
			</template>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Audience',

	data() {
		return {
			columns: [
				{
					align: 'left',
					field: 'user_id',
					label: '#',
					name: 'user_id',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'user_full_name',
					label: 'name',
					name: 'user_full_name',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'user_email',
					label: 'email',
					name: 'user_email',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'user_profile',
					label: 'profile',
					name: 'user_profile',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'user_points',
					label: 'user_available_points',
					name: 'user_points',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'user_total_points',
					label: 'total_points',
					name: 'user_total_points',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'user_status',
					label: 'status',
					name: 'user_status',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'actions',
					label: '',
					name: 'actions',
					required: true,
					sortable: true,
				},
			],
			confirm_block_user: false,
			confirm_email_end_of_campaign: false,
			confirm_email_points_available: false,
			confirm_remove_user: false,
			confirmation_block_user: false,
			confirmation_email_end_of_campaign: false,
			confirmation_email_points_available: false,
			confirmation_remove_user: false,
			data: [],
			data: [],
			loading: false,
			server_pagination: {
				descending: false,
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				sortBy: null,
			},
			user: {},
			filter: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			num_rows: 'datatable/num_rows',
			id: 'campaigns/id',
			status: 'campaigns/status',
			title: 'campaigns/title',
			sub_title: 'campaigns/sub_title',
			description: 'campaigns/description',
			campaign_url: 'campaigns/campaign_url',
			image: 'campaigns/image',
			area: 'campaigns/areas',
			profile: 'campaigns/profiles',
			start_date: 'campaigns/start_date',
			end_date: 'campaigns/end_date',
			company_branches: 'campaigns/company_branches',
			brands: 'campaigns/brands',
			product_types: 'campaigns/product_types',
			products: 'campaigns/products',
			rewards: 'campaigns/rewards',
			allow_sells: 'campaigns/allow_sells',
			training_kpi_points: 'campaigns/training_kpi_points',
			training_non_kpi_points: 'campaigns/training_non_kpi_points',
			image_banner: 'campaigns/image_banner',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
				search: this.filter,
			}

			this.savePagination()

			this.$axios
				.get(
					`/admin_rewards/campaigns/${this.id}/users/?` + this.$qs.stringify(data),
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					this.data = response.data.results.map((e) => ({ ...e, actions: e.user_id }))
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		confirmBlockUser(user) {
			this.user = user
			this.confirm_block_user = true
		},

		blockUser() {
			this.$q.loading.show()
			this.confirm_block_user = false

			this.$axios
				.get(
					`/admin_rewards/campaigns/${this.id}/users/${this.user.user_id}/block_user/`,
					this.getHeader
				)
				.then(() => {
					this.confirmation_block_user = true
					this.request({ pagination: this.server_pagination })
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		confirmRemoveUser(user) {
			this.user = user
			this.confirm_remove_user = true
		},

		removeUserFromCampaign() {
			this.$q.loading.show()
			this.confirm_remove_user = false

			this.$axios
				.get(
					`/admin_rewards/campaigns/${this.id}/users/${
						this.user.user_id
					}/remove_user_from_campaign/`,
					this.getHeader
				)
				.then(() => {
					this.confirmation_remove_user = true
					this.request({ pagination: this.server_pagination })
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		sendEmailPointsAvailable() {
			this.$q.loading.show()
			this.confirm_email_points_available = false

			this.$axios
				.get(`/admin_rewards/campaigns/${this.id}/email_users_reminder/`, this.getHeader)
				.then(() => {
					this.confirmation_email_points_available = true
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		sendEmailEndOfCampaign() {
			this.$q.loading.show()
			this.confirm_email_end_of_campaign = false

			this.$axios
				.get(
					`/admin_rewards/campaigns/${this.id}/email_campaign_finishing/`,
					this.getHeader
				)
				.then(() => {
					this.confirmation_email_end_of_campaign = true
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		getStatus(status) {
			if (status == 1) return 'active'
			else if (status == 2) return 'inactive'
			else if (status == 3) return 'deleted'
			else if (status == 4) return 'awaiting_validation'
			else if (status == 5) return 'active_web_service'
			else if (status == 6) return 'self_registered'
			else if (status == 6) return 'inactive_web_service'
			else if (status == 8) return 'blocked'
		},

		getIconStatus(status) {
			if (status == 1) return 'fas fa-check'
			else if (status == 2) return 'fas fa-ban'
			else if (status == 3) return 'fas fa-trash-alt'
			else if (status == 4) return 'fas fa-exclamation-triangle'
			else if (status == 5) return 'fab fa-internet-explorer'
			else if (status == 6) return 'fas fa-portrait'
			else if (status == 7) return 'fas fa-ban'
			else if (status == 8) return 'fas fa-ban'
		},

		getColorStatus(status) {
			if (status == 1) return 'positive'
			else if (status == 2) return 'warning'
			else if (status == 3) return 'negative'
			else if (status == 4) return 'warning'
			else if (status == 5) return 'positive'
			else if (status == 6) return 'info'
			else if (status == 7) return 'warning'
			else if (status == 8) return 'negative'
		},
	},

	created() {
		this.loadPagination()
		this.request({ pagination: this.server_pagination })
	},
}
</script>

<style></style>
